import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function parseJsonProperty<T>(value: string | undefined, fallback: T): T {
  if (!value) {
    return fallback
  }

  try {
    return JSON.parse(value) as T
  } catch {
    return fallback
  }
}

export function getInitials(name: string | undefined | null) {
  if (!name || typeof name !== 'string') {
    return '??'
  }
  
  return name
    .split(' ')
    .slice(0, 2)
    .map(word => word.charAt(0))
    .join('')
    .toUpperCase()
}

export function unique(array: any[]) {
  return array.filter((item, index, self) => self.indexOf(item) === index);
}

export function removeNulls(array: any[]) {
  return array.filter(item => item !== null);
}

export function formatDateShort(value: string): string {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value

  return new Intl.DateTimeFormat("ru-RU", {
    day: "numeric",
    month: "long",
  }).format(date)
}

export function formatAmount(amount: number): string {
  return `${new Intl.NumberFormat("ru-RU").format(amount)} руб.`
}

export function formatDateExtended(value: string): string {
  const date = new Date(value)

  if (Number.isNaN(date.getTime())) {
    return value
  }

  return new Intl.DateTimeFormat("ru-RU", {
    day: "numeric",
    month: "long",
    year: "numeric",
  })
    .format(date)
    .replace(" г.", "")
}